import React, { useState } from "react";
import YouTube from "react-youtube";
import styled from "styled-components";

import { RenderImportantComponent } from "@components/RenderImportantCampaign";

import { FireAlarm } from "./FireAlarm";

const Container = styled.div`
  width: 1920px;
  height: 1080px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default () => {
  const [isFire, setIsFire] = useState(false);
  return (
    <Container>
      {/* {isFire && ( */}
      <FireAlarm />
      {/* )} */}

      <img
        src="https://get-led-api.forvizdev.com/uploads/medias/customer_1/location_1/878563f8-24b9-4358-ac65-d1d6728a397b.jpg"
        alt="-"
        style={{ width: "100%", height: "100%", objectFit: "fill" }}
      />
      {/* <YouTube
        videoId={"l7UyovLnLXc"}
        opts={{
          playerVars: {
            autoplay: true,
          },
        }}
      /> */}
    </Container>
  );
};
